import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'cv-custom-active-cell',
	templateUrl: './custom-active-cell.component.html',
	styleUrls: ['./custom-active-cell.component.scss']
})
export class CustomActiveCellComponent implements ICellRendererAngularComp {
	cellValue: boolean;

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		if (params.value) {
			this.cellValue = params.value;
		}
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params.value;
		return true;
	}
}
